import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { notification, Tabs } from 'antd';

import { useBreedersContext } from 'dogpark/context';
import { BreedersTable, DogParkLayout } from 'dogpark/components';
import { getBreeders } from 'dogpark/utilities/breeders/getBreeders/getBreeders';
import { BreedersRouteParams } from 'dogpark/types';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { BreadcrumbItem } from 'types';

const { TabPane } = Tabs;

const breadcrumbs: BreadcrumbItem[] = [
  {
    key: 'main',
    label: 'Main',
    path: '/',
  },
  {
    key: 'dogPark',
    label: 'DogPark',
  },
  {
    key: 'breeders',
    label: 'Breeders',
  },
];

function Breeders(): ReactElement {
  const { dispatch: dispatchLayout } = useLayoutState();
  const {
    state: { fetchBreeders },
    dispatch,
  } = useBreedersContext();
  const { searchBy, searchValue } = useParams<BreedersRouteParams>();

  useEffect(() => {
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs });
    dispatch({ type: 'SET_FETCH_BREEDERS' });
  }, [searchBy, searchValue]);

  useEffect(() => {
    const handleFetchBreeders = async () => {
      try {
        dispatch({ type: 'LOAD_BREEDERS' });
        const breeders = await getBreeders(searchBy, searchValue);
        dispatch({ type: 'SET_BREEDERS', payload: { breeders } });
      } catch (e) {
        e.message && notification.error({ key: 'getBreederError', message: e.message });
        dispatch({ type: 'SET_BREEDERS', payload: { breeders: [] } });
      }
    };

    fetchBreeders && handleFetchBreeders();
  }, [fetchBreeders]);

  return (
    <DogParkLayout>
      <Tabs defaultActiveKey="breeders">
        <TabPane tab="Breeders" key="breeders">
          <BreedersTable />
        </TabPane>
      </Tabs>
    </DogParkLayout>
  );
}

export default Breeders;
